import * as React from 'react';
import SxProps from 'threads5/themes/sx-props';
import type { ITheme } from 'threads5/themes/theme';
import { Wrapper } from 'src/containers';
import { Column } from 'src/components-v2/Layout';

interface ISectionalHeadingProps {
  children: React.ReactNode;
  sx?: SxProps<ITheme>;
}

const SectionalHeading = React.forwardRef(
  ({ children, sx }: ISectionalHeadingProps, ref) => {
    return (
      <Wrapper component='header' sx={{ ...sx }} ref={ref}>
        <Column xs={22} xsOffset={1} lg={20} lgOffset={2}>
          {children}
        </Column>
      </Wrapper>
    );
  },
);

export default SectionalHeading;
